<div class="quick-select-container">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'Contacts.Import.QuickSelectGroups' | translate: locale.language }}</mat-label>
    <mat-chip-grid #chipGrid>
      @for (group of selectedGroups(); track group.id) {
        <mat-chip-row [removable]="true" (removed)="removeGroup(group)">
          {{ group.name }}
          <button matChipRemove [attr.aria-label]="'Remove ' + group.name">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>

    <input
      matInput
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [formControl]="searchControl"
      [placeholder]="'Contacts.Import.TypeToSearchGroups' | translate: locale.language"
      #groupInput />

    <mat-autocomplete #auto="matAutocomplete"
                     [displayWith]="displayGroupFn"
                     (optionSelected)="onGroupSelected($event)">
      @for (group of filteredGroups(); track group.id) {
        <mat-option [value]="group">
          <div class="autocomplete-option">
            <span class="group-name">{{ group.name }}</span>
            @if (group.path) {
              <span class="group-path">{{ group.path }}</span>
            }
            @if (group.memberCount != null) {
              <span class="group-member-count">({{ group.memberCount }} {{ 'Contacts.Management.Groups.Members' | translate: locale.language }})</span>
            }
          </div>
        </mat-option>
      }
    </mat-autocomplete>

    <mat-hint>{{ 'Contacts.Import.TypeAtLeast2Chars' | translate: locale.language }}</mat-hint>
  </mat-form-field>

  <button mat-stroked-button
          color="primary"
          (click)="openAdvancedDialog()"
          class="advanced-button">
    <mat-icon>folder_open</mat-icon>
    {{ 'Contacts.Import.AdvancedSelection' | translate: locale.language }}
  </button>
</div>
